export function ptToMm(pt: number): number {
  return pt * 0.352778;
}
